import Error from "@/shared/ui/layout/error";

export default function MaintenanceProvider({
  children,
}: MaintenanceProviderProps) {
  const isMaintenanceMode = import.meta.env.VITE_MAINTENANCE === "true";
  const maintenanceUntil = import.meta.env.VITE_MAINTENANCE_UNTIL?.trim();

  if (isMaintenanceMode) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-white px-5">
        <div className="w-full pb-8">
          <Error title="서비스 점검 안내">
            <>
              {maintenanceUntil
                ? `점검일시: ${maintenanceUntil}`
                : "현재 긴급 서비스 점검 중입니다."}
              <br />
              이용에 불편을 드려 죄송합니다.
            </>
          </Error>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

interface MaintenanceProviderProps {
  children: React.ReactNode;
}
